// extracted by mini-css-extract-plugin
export var breakLine = "BreakLine_breakLine__Qst2N";
export var lg = "992px";
export var md = "768px";
export var shared = "'../../../shared.module.css'";